<template>
    <div id="fortune-teller-game" class="game">
        <router-link to="/" tag="div" class="close">×</router-link>
        <h1>Fortune teller</h1>
        <form class="game-wrapper layout-1" @submit="play">
            <div class="layout-content">
                <div id="fortune-teller-game-model"></div>
                <div v-if="answer" id="fortune-teller-game-answer">{{ answer }}</div>
            </div>
            <div class="layout-navigation" id="fortune-teller-game-question-wrapper">
                <select id="fortune-teller-game-question-category" v-model="category">
                    <option value="0">Why</option>
                    <option value="1">Who</option>
                    <option value="2">When</option>
                    <option value="3">Where</option>
                </select>
                <input id="fortune-teller-game-question-text" type="text" value=""
                       placeholder="Type here your question" v-model="question" required="required"
                       autocomplete="off" @focus="resetAnswer" />
                <button class="action-button">?</button>
            </div>
        </form>
    </div>
</template>

<script>

  import Random from './../utils/random'

  const in_the_soul = {'text': "My crystal ball says that you know the answer. Just find the answer in your soul.", 'audio': '/audio/fortune-teller/in-the-soul.mp3'};
  const ask_yourself = {'text': "You're asking me, but... Ask yourself to find the answer.", 'audio': '/audio/fortune-teller/ask-yourself.mp3'};

  export default {
    data: function () {
      return {
        'answer': null,
        'question': '',
        'category': 0,
        'answers': [
          [
            {'text': "You're asking \"why\", but is it the question?", 'audio': '/audio/fortune-teller/but-is-it-why.mp3'},
            ask_yourself,
            in_the_soul,
            {'text': "I'm looking through my crystal ball and I see something. I see stars... Millions of them. And they are silent.", 'audio': '/audio/fortune-teller/stars.mp3'},
            {'text': "Everything in the universe is connected. So, you want to know \"why\"? Because of the everything.", 'audio': '/audio/fortune-teller/because-everything.mp3'},
            {'text': "Everything has causes and consequences. Sometimes you can't say for sure what is what...", 'audio': '/audio/fortune-teller/what-is-what.mp3'},
          ],
          [
            {'text': "You're asking \"who\", but is it the question?", 'audio': '/audio/fortune-teller/but-is-it-who.mp3'},
            ask_yourself,
            in_the_soul,
            {'text': "I never saw the answer more clear. You know the person or you don't.", 'audio': '/audio/fortune-teller/know-person.mp3'},
            {'text': "Who knows... Who knows... I know! It is the right person.", 'audio': '/audio/fortune-teller/who-knows-right-person.mp3'},
            {'text': "My crystal ball is unclear, but it seems to be a person.", 'audio': '/audio/fortune-teller/seems-person.mp3'},
            {'text': "I'm asking stars and they are giving me the answer: it is somebody.", 'audio': '/audio/fortune-teller/somebody.mp3'},
          ],
          [
            {'text': "You're asking \"when\", but is it the question?", 'audio': '/audio/fortune-teller/but-is-it-when.mp3'},
            ask_yourself,
            in_the_soul,
            {'text': "Everything happens in the moment when it should happened.", 'audio': '/audio/fortune-teller/happens-should.mp3'},
            {'text': "Everything happens in every moment in the infinite universe.", 'audio': '/audio/fortune-teller/happens-every.mp3'},
            {'text': "Time is an abstraction. Was it in the past, will it be in the future? Is there any difference?", 'audio': '/audio/fortune-teller/time-abstraction.mp3'},
          ],
          [
            {'text': "You're asking \"where\", but is it the question?", 'audio': '/audio/fortune-teller/but-is-it-where.mp3'},
            ask_yourself,
            in_the_soul,
            {'text': "I'm looking through my crystal ball and see the stars. They are so beautiful and so far... So what are looking for seems to be closer.", 'audio': '/audio/fortune-teller/start-closer.mp3'},
            {'text': "I see... I see... I see this place in my crystal ball. It is a very special place in this context.", 'audio': '/audio/fortune-teller/very-special-place﻿.mp3'},
            {'text': "I'm asking stars and they are giving me the answer: this location is somewhere.", 'audio': '/audio/fortune-teller/somewhere.mp3'},
          ],
        ],
      }
    },
    methods: {
      play: function (e) {
        e.preventDefault();
        let question_sum = 0;
        const c_code = this.$data.question.split(' ').join('');
        for (let i = 0; i < c_code.length; i++) {
          question_sum += c_code.charCodeAt(i);
        }
        const cache = `ft-cache-${this.$data.category}-${question_sum}`;
        let number = sessionStorage.getItem(cache);
        if (!number) {
          number = Random.getNumber(0, this.$data.answers[this.$data.category].length - 1);
          sessionStorage.setItem(cache, number.toString());
        } else {
          number = parseInt(number);
        }
        const answer = this.$data.answers[this.$data.category][number];
        if (answer.text !== this.$data.answer) {
          this.$data.answer = answer.text;
          (new Audio(answer.audio)).play();
        }
      },
      resetAnswer: function () {
        this.$data.answer = null;
      },
    }
  }
</script>

<style src="./../assets/css/game.css" scoped></style>
<style scoped>
    #fortune-teller-game {
        background-image: url('../assets/img/game/fortune-teller/bg.jpg');
        background-size: cover;
    }

    #fortune-teller-game-question-wrapper {
        display: flex;
    }

    #fortune-teller-game-question-wrapper > *:nth-child(1) {
        padding-right: 0;
    }

    #fortune-teller-game-question-wrapper > *:nth-child(2) {
        padding-right: 0;
        width: 100%;
    }

    #fortune-teller-game-answer {
        position: absolute;
        bottom: 2rem;
        left: 1rem;
        right: 1rem;
        text-align: center;
        font-size: 32pt;
        line-height: 40pt;
        color: #ffffff;
        text-shadow: 0 0 1rem rgba(0,0,0,1), 0 0 1rem rgba(0,0,0,1), 0 0 1rem rgba(0,0,0,1);
    }

    #fortune-teller-game-answer:before {
        content: '— ';
    }

    #fortune-teller-game-answer:empty {
        display: none;
    }

    #fortune-teller-game-model {
        width: 100%;
        height: 100%;
        background: 50% 50% url('./../assets/img/game/fortune-teller/model.png') no-repeat;
        background-size: contain;
    }
</style>
